import Axios from "axios";
import {
  setRequestInterceptor,
  setResponseInterceptor,
} from "./interceptors/index";

export const configureApi = () => {
  Axios.defaults.baseURL = `${process.env.VUE_APP_LARAVEL_URL}/api`;
  setRequestInterceptor();
  setResponseInterceptor();
};
